import { SERVICES } from './index';
import { Action } from '../action';
import { ServiceInfo } from '@shared/core';

export class ServicesHydrateAction implements Action {
	readonly type = SERVICES.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ServicesHydrateSuccessAction implements Action {
	readonly type = SERVICES.HYDRATE_SUCCESS;
	constructor(
		public payload: ServiceInfo[],
		public correlationId?: number
	) {}
}

export class ServicesHydrateFailureAction implements Action {
	readonly type = SERVICES.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
